import * as React from 'react';
import { FC, useState } from 'react';
import { moneyStr } from 'app/helpers/money';
import { JackpotAggregatorCampaignViewProps } from './types';
import Winners from './Winners';

type ActiveTabsType = 'top' | 'recent';

const Leaderboards: FC<JackpotAggregatorCampaignViewProps> = (props) => {
  const [activeTab, setActiveTab] = useState<ActiveTabsType>('top');
  const handleTabChange = (tab: ActiveTabsType) => {
    setActiveTab(tab);
  };
  const getTabClassName = (title: ActiveTabsType) => (activeTab === title ? 'active' : '');
  return (
    <div className="j-w_leaderboard jw-leaderboard">
      <div className="jw-leaderboard_wrapper">
        <div className="jw-leaderboard_top">
          <div className="jw-leaderboard_pool" id="pool">
            <p>
              {props.locales.total_winnings_pool}{' '}
              <span aria-labelledby="pool">{moneyStr(props.pool, props.currency)}</span>
            </p>
          </div>
        </div>
        <div className="jw-leaderboard_content">
          <ul className="jw-leaderboard_tabs-list">
            <li className={`jw-leaderboard_tabs-item jw-tab ${getTabClassName('top')}`}>
              <div className="jw-tab_button" onClick={() => handleTabChange('top')}>
                {props.locales.top_winners}
              </div>
            </li>
            <li className={`jw-leaderboard_tabs-item jw-tab ${getTabClassName('recent')}`}>
              <div className="jw-tab_button" onClick={() => handleTabChange('recent')}>
                {props.locales.recent_winners}
              </div>
            </li>
          </ul>
          <ul className="jw-leaderboard_table-list">
            <Winners
              title={props.locales.top_winners}
              winners={props.top_winners}
              currency={props.currency}
              language={props.language}
              activeClass={getTabClassName('top')}
            />
            <Winners
              title={props.locales.recent_winners}
              winners={props.recent_winners}
              currency={props.currency}
              language={props.language}
              activeClass={getTabClassName('recent')}
            />
          </ul>
        </div>
      </div>
    </div>
  );
};
export default Leaderboards;
